import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea43941c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box_swiper" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_typography = _resolveComponent("a-typography")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!
  const _component_LeftOutlined = _resolveComponent("LeftOutlined")!
  const _component_RightOutlined = _resolveComponent("RightOutlined")!

  return ($data.expand.show)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", {
          class: _normalizeClass(["box", $props.type])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_Swiper, {
              class: "box_carousel",
              autoHeight: true,
              loop: "",
              autoplay: {delay:30000,disableOnInteraction:false,pauseOnMouseEnter:true},
              keyboard: {enabled:true,onlyInViewport:true},
              slidesPerView: 1,
              speed: 600,
              navigation: {prevEl:' .button_prev',nextEl:'.button_next',disabledClass:'button_disabled'},
              pagination: {clickable:true}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.bannerList, (item) => {
                  return (_openBlock(), _createBlock(_component_SwiperSlide, {
                    key: item.id
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["box_panel box_panel_bg box_text", {isDetail: $props.isDetail}]),
                        style: _normalizeStyle({'--title_light':`${$options.rgba(item.title_light||'#ffffff',0.8)}`,'--content_light':`${$options.rgba(item.content_light||'#ffffff',0.8)}`})
                      }, [
                        _createElementVNode("i", {
                          class: "box_bg",
                          style: _normalizeStyle({'background-image':`url(${item.bg_image})`})
                        }, null, 4 /* STYLE */),
                        _createVNode(_component_a_row, {
                          type: "flex",
                          class: "box_row",
                          style: _normalizeStyle(_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.LG)?'':{'flex-direction': 'column'})
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, { flex: "1 1 auto" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_typography, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_typography_title, { level: 5 }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          class: "title_html",
                                          innerHTML: item.title
                                        }, null, 8 /* PROPS */, _hoisted_2)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */),
                                    _createVNode(_component_a_typography_paragraph, {
                                      style: _normalizeStyle(_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.LG)?{'font-size': '14px','line-height': '21px'}:'')
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", {
                                          class: "title_html",
                                          innerHTML: item.content
                                        }, null, 8 /* PROPS */, _hoisted_3)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["style"])
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */),
                            _createVNode(_component_a_col, {
                              flex: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.LG)?'0 0 260px':'',
                              style: _normalizeStyle(_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.LG)?'':{'justify-content': 'center',width:'100%','margin-top': '10px'})
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "link",
                                  class: "button",
                                  style: _normalizeStyle({'background-color':`${item.button_bg_color} !important`,'color':`${item.button_text_color} !important`}),
                                  onClick: ($event: any) => ($options.clickButton(item))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("p", {
                                      innerHTML: item.button_text
                                    }, null, 8 /* PROPS */, _hoisted_4)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["style", "onClick"])
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["flex", "style"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["style"])
                      ], 6 /* CLASS, STYLE */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["navigation"]),
            _createCommentVNode(" <template v-if=\"expand.bannerList.length > 1\"> "),
            _createVNode(_component_a_button, {
              type: "link",
              class: "button_prev",
              style: _normalizeStyle({display:$data.expand.bannerList.length > 1?'block':'none'})
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_LeftOutlined)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["style"]),
            _createVNode(_component_a_button, {
              type: "link",
              class: "button_next",
              style: _normalizeStyle({display:$data.expand.bannerList.length > 1?'block':'none'})
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_RightOutlined)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["style"]),
            _createCommentVNode(" </template> ")
          ])
        ], 2 /* CLASS */),
        _createCommentVNode("<div class=\"box_panel box_video\">"),
        _createCommentVNode("    <video ref=\"video\""),
        _createCommentVNode("           :src=\"href.video\" :poster=\"file.ImageVideoCover\""),
        _createCommentVNode("           controls preload />"),
        _createCommentVNode("</div>")
      ], 64 /* STABLE_FRAGMENT */))
    : _createCommentVNode("v-if", true)
}